import React from 'react';
import { ChangeRequestAttachment } from '@/types';
import { getOpenChangeRequestAttachmentUrl } from '@/services/change-requests';
import AttachmentList from '@/components/AttachmentList/AttachmentList';
import { AttachmentListProps } from '@/components/AttachmentList';

const ChangeRequestAttachmentList: React.FC<AttachmentListProps<ChangeRequestAttachment>> = ({ ...rest }) => {
    return (
        <AttachmentList<ChangeRequestAttachment>
            {...rest}
            urlGenerator={(att) => getOpenChangeRequestAttachmentUrl(att.id)}
        />
    );
};

export default ChangeRequestAttachmentList;